export async function loadCurrentUser() {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=get_current_user`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include"
  });

  if (response.ok) {
    const user = await response.json();
    return user;
  }

  return null;
}
